var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import { tvAuthService } from '../../services/TvAuthService';
import { Loader } from '../../components/Loader/Loader';
import { LoaderType } from '../../components/Loader/LoaderType.enum';
import SetPassword from './SetPassword/Set-password';
import SetLoginId from './SetLoginId/Set-loginId';
var SetLoginIdPassword = (function (_super) {
    __extends(SetLoginIdPassword, _super);
    function SetLoginIdPassword(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSave = function (msisdn) {
            var cleanMsisdn = tvAuthService.removeSpaces(msisdn);
            if (_this.getUrlParams('subscriptionId') && _this.getUrlParams('motp') && cleanMsisdn && _this.isValidPhone(cleanMsisdn)) {
                _this.setState({ isLoading: true, msisdn: msisdn });
                tvAuthService.setMsisdn(cleanMsisdn, _this.getUrlParams('motp'), _this.getUrlParams('subscriptionId'), _this.updateSuccess, _this.updateError);
            }
        };
        _this.updateSuccess = function () {
            _this.setState({ isLoading: false, activeStep: 2 });
        };
        _this.updateError = function (response) {
            _this.setState({ isError: true, errorCode: response.errorCode, isLoading: false });
        };
        _this.getUrlParams = function (params) {
            var urlParams = new URLSearchParams(location.search.replace('#/', ''));
            return urlParams && urlParams.get(params) || '';
        };
        _this.updateStep = function (activeStep) {
            _this.setState({
                activeStep: activeStep
            });
        };
        _this.isPasswordSet = function (passwordSetSuccess) {
            _this.setState({
                passwordSetSuccess: passwordSetSuccess
            });
        };
        _this.state = {
            activeStep: 1,
            msisdn: '',
            isLoading: false,
            isError: false,
            errorCode: '',
            passwordSetSuccess: false
        };
        return _this;
    }
    SetLoginIdPassword.prototype.isValidPhone = function (phoneNumber) {
        var regExp = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/im;
        return regExp.test(phoneNumber);
    };
    SetLoginIdPassword.prototype.renderSteps = function () {
        var t = this.props.t;
        var _a = this.state, activeStep = _a.activeStep, passwordSetSuccess = _a.passwordSetSuccess;
        return (React.createElement(React.Fragment, null,
            React.createElement("ol", { className: "s20-step-tracker-v2 " + (passwordSetSuccess ? 's20-step-tracker-v2--completed' : '') },
                React.createElement("li", { className: "s20-step-tracker-v2__item " + (activeStep === 1 ? 's20-step-tracker-v2__item--active' : 's20-step-tracker-v2__item--completed') },
                    React.createElement("div", { className: "s20-step-tracker-v2__indicator" },
                        React.createElement("div", { className: "s20-step-tracker-v2__number" }, "1"),
                        React.createElement("div", { className: "s20-step-tracker-v2__title" }, t("SetLogin.Progress.Bar.Title")))),
                React.createElement("li", { className: "s20-step-tracker-v2__item " + (activeStep === 2 ? 's20-step-tracker-v2__item--active' : '') },
                    React.createElement("div", { className: "s20-step-tracker-v2__indicator" },
                        React.createElement("div", { className: "s20-step-tracker-v2__number" }, "2"),
                        React.createElement("div", { className: "s20-step-tracker-v2__title" }, t("SePassword.Progress.Bar.Title")))))));
    };
    SetLoginIdPassword.prototype.render = function () {
        var location = this.props.location;
        var _a = this.state, isLoading = _a.isLoading, errorCode = _a.errorCode, activeStep = _a.activeStep, msisdn = _a.msisdn, isError = _a.isError;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "s20-spacer s20-spacer--x60" }),
            React.createElement("div", { className: "l-center-l" },
                isLoading ? React.createElement(Loader, { type: LoaderType.LIGHT }) : null,
                this.renderSteps(),
                React.createElement("div", { className: "s20-spacer s20-spacer--x72" }),
                activeStep === 2 ?
                    React.createElement(SetPassword, { activeStep: activeStep, loginId: msisdn, updateStep: this.updateStep, isPasswordSet: this.isPasswordSet }) :
                    React.createElement(SetLoginId, { location: location, onClick: this.handleSave, errorCode: errorCode, isError: isError, msisdn: msisdn })),
            React.createElement("div", { className: "s20-spacer s20-spacer--x60" })));
    };
    return SetLoginIdPassword;
}(React.Component));
export default withTranslation()(SetLoginIdPassword);
